
import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import './styles.css'
import App from './App'
import Home from './routes/Home'
import Services from './routes/Services'
import Pricing from './routes/Pricing'
import Success from './routes/Success'
import CaseStudies from './routes/CaseStudies'
import About from './routes/About'
import Contact from './routes/Contact'
import Privacy from './routes/legal/Privacy'
import Terms from './routes/legal/Terms'
import Refunds from './routes/legal/Refunds'
import Cookies from './routes/legal/Cookies'

const router = createBrowserRouter([
  { path: '/', element: <App />, children: [
    { index: true, element: <Home /> },
    { path: 'services', element: <Services /> },
    { path: 'pricing', element: <Pricing /> },
    { path: 'success', element: <Success /> },
    { path: 'case-studies', element: <CaseStudies /> },
    { path: 'about', element: <About /> },
    { path: 'contact', element: <Contact /> },
    { path: 'legal/privacy', element: <Privacy /> },
    { path: 'legal/terms', element: <Terms /> },
    { path: 'legal/refunds', element: <Refunds /> },
    { path: 'legal/cookies', element: <Cookies /> },
  ]}
])

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
)
